<script setup lang="ts">
const {
  errorMessages = [],
  readonly = false,
  disabled = false,
  label = '',
  placeholder = '',
} = defineProps<{
  errorMessages?: string | string[];
  readonly?: boolean;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
}>();

const select = defineModel<string | number>();
</script>
<template>
  <v-select
    v-model="select"
    flat
    variant="solo-filled"
    hide-details="auto"
    :error-messages="errorMessages"
    :placeholder="placeholder"
    :label="label"
    :readonly="readonly"
    :disabled="disabled"
  ></v-select>
</template>

<style></style>
